import React, { useState, useContext, useEffect, forwardRef, useImperativeHandle } from 'react';
import { BiChevronUp } from 'react-icons/bi';
import { FaCheck } from 'react-icons/fa';
import { ForwardFittingContext } from "../../ForewardFitting/ForwardFittingContext";
import { FaArrowsAltV, FaArrowsAltH } from "react-icons/fa";
import StickImage from "../../../assets/images/stick_image.png";
import StickSvg from '../SvgData/StickSvg';
import { Form } from 'react-bootstrap';
import { MdRemoveRedEye, MdCheck } from "react-icons/md";
import { FaTimesCircle } from "react-icons/fa";
import { Modal, ProgressBar } from 'react-bootstrap';
import './progessbar.css'
import { ImCross } from "react-icons/im";




const IronsData = forwardRef(({ step, iron, title, options, number, shotOpction, shortStrike, options2, activeEyes }, ref) => {

    const { remotefittingdata, setRemotefittingdata, updateremotefitting } = useContext(ForwardFittingContext);

    const [isEyeActive, setIsEyeActive] = useState(false);

    useEffect(() => {

        setIsEyeActive(false);
      
    }, [step, iron])

    useEffect(() => {

        if (activeEyes && activeEyes[step] && activeEyes[step][iron]) {

            setIsEyeActive(true);
        }

    }, [activeEyes, step, iron])



    const [isValidated, setIsValidated] = useState(false);

    useEffect(() => {
        console.log("eye changed ", isEyeActive)
    }, [isEyeActive])

    useEffect(() => {
        setIsValidated(false);
    }, [step, iron]);


    useImperativeHandle(ref, () => ({


        validate: () => {
            let isValid = true;

            if (!remotefittingdata[step][iron].shot1.optionx
                || !remotefittingdata[step][iron].shot1.optiony
                || !remotefittingdata[step][iron].shot1.option1
                || !remotefittingdata[step][iron].shot1.option2) {
                isValid = false;

                setIsValidated(true);

            }

            if (!remotefittingdata[step][iron].shot2.optionx
                || !remotefittingdata[step][iron].shot2.optiony
                || !remotefittingdata[step][iron].shot2.option1
                || !remotefittingdata[step][iron].shot2.option2) {
                isValid = false;
            }

            if (!remotefittingdata[step][iron].shot3.optionx
                || !remotefittingdata[step][iron].shot3.optiony
                || !remotefittingdata[step][iron].shot3.option1
                || !remotefittingdata[step][iron].shot3.option2) {
                isValid = false;
            }

            return isValid;
        }
    }));


    const [selectedNUmberX, setSelectedNUmberX] = useState(0);
    const [selectedNUmberY, setSelectedNUmberY] = useState(0);

    const [showModal, setShowModal] = useState(false);

    const [dropdownState, setDropdownState] = useState({
        isOpen1: false,
        isOpen2: false,
        isOpen3: false,
        isOpenx: false,
        isOpeny: false
    });

    const [dropdownState2, setDropdownState2] = useState({
        isOpen1: false,
        isOpen2: false,
        isOpen3: false,
        isOpenx: false,
        isOpeny: false
    });
    const [dropdownState3, setDropdownState3] = useState({
        isOpen1: false,
        isOpen2: false,
        isOpen3: false,
        isOpenx: false,
        isOpeny: false
    });


    const handleToggleDropdown = (dropdownName) => {
        setDropdownState((prevState) => ({
            ...prevState,
            [dropdownName]: !prevState[dropdownName],
        }));
    };

    const handleToggleDropdown2 = (dropdownName) => {
        setDropdownState2((prevState) => ({
            ...prevState,
            [dropdownName]: !prevState[dropdownName],
        }));
    };

    const handleToggleDropdown3 = (dropdownName) => {
        setDropdownState3((prevState) => ({
            ...prevState,
            [dropdownName]: !prevState[dropdownName],
        }));
    }


    const handleOptionClick1 = (option, path) => {
        updateremotefitting(path, option.text, option.id);
    };

    const handleOptionClickResult = (option, path) => {
        updateremotefitting(path, option.text, option.id);
    }

    useEffect(() => {
        // set all dropedown to false
        setDropdownState({
            isOpen1: false,
            isOpen2: false,
            isOpen3: false
        });

        setDropdownState2({
            isOpen1: false,
            isOpen2: false,
            isOpen3: false
        });

        setDropdownState3({
            isOpen1: false,
            isOpen2: false,
            isOpen3: false
        });

    }, [remotefittingdata])



    const handleOptionStrickY = (option, shotoption, shot) => {
        const newOption = { ...option, shot: shot };
        setSelectedNUmberX(newOption);

        handleOptionClick1(option, step + "." + iron + shotoption)
    };

    const handleOptionStrickX = (option, shotoption, shot) => {
        const newOption = { ...option, shot: shot };
        setSelectedNUmberY(newOption);

        handleOptionClick1(option, step + "." + iron + shotoption);
    };


    // useEffect(() => {
    //     if (selectedNUmberX && selectedNUmberY) {
    //         const element = document.getElementById(`x${selectedNUmberX}y${selectedNUmberY}`);
    //         if (element) {
    //             element.setAttribute('fill', '#99ea24'); // Change fill color
    //             element.setAttribute('fill-opacity', '0.5'); // Change fill-opacity
    //         }
    //     }
    // }, [selectedNUmberX, selectedNUmberY])


    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const allShotsFilled =
        remotefittingdata?.[step]?.[iron]?.shot1?.optionx &&
        remotefittingdata?.[step]?.[iron]?.shot1?.optiony &&
        remotefittingdata?.[step]?.[iron]?.shot1?.option1 &&
        remotefittingdata?.[step]?.[iron]?.shot1?.option2 &&
        remotefittingdata?.[step]?.[iron]?.shot2?.optionx &&
        remotefittingdata?.[step]?.[iron]?.shot2?.optiony &&
        remotefittingdata?.[step]?.[iron]?.shot2?.option1 &&
        remotefittingdata?.[step]?.[iron]?.shot2?.option2 &&
        remotefittingdata?.[step]?.[iron]?.shot3?.optionx &&
        remotefittingdata?.[step]?.[iron]?.shot3?.optiony &&
        remotefittingdata?.[step]?.[iron]?.shot3?.option1 &&
        remotefittingdata?.[step]?.[iron]?.shot3?.option2;

    const [show03, setShow03] = useState(false);
    const handleClose03 = () => setShow03(false);

    const handleShow03 = () => setShow03(true);



    return (
        <>

            <Modal
                show={show03}
                onHide={handleClose03}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <h2 className="text-center mb-3">
                        You missed something!
                    </h2>
                    <p className="text-center mb-4">
                        Please fill out every input field in the above section.
                    </p>

                    <button type="button" className="btn btn-modal-view" onClick={handleClose03}>
                        OK, got it!
                    </button>
                </Modal.Body>
            </Modal>
            <div className='ironProgressDesign'>
                <div className="new-design-border-sec">
                    <div className="sec-header-dash border-header-sec new-design-header white">
                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                            <h3 className="box-title-lable">
                                <span className="color">{number}</span> {title}
                            </h3>
                        </div>

                        {/* <div className="content-box-btn">
                            <div className={` ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot1 && remotefittingdata[step][iron].shot1.option1 && remotefittingdata[step][iron].shot1.option2 && remotefittingdata[step][iron].shot2.option1 && remotefittingdata[step][iron].shot2.option2 && remotefittingdata[step][iron].shot3.option1 && remotefittingdata[step][iron].shot3.option2 ? 'head_check_completed' : 'head_check'}`}
                                onClick={handleShowModal}
                                style={{ cursor: 'pointer' }} >
                                <MdRemoveRedEye size={22} />
                            </div>
                        </div> */}

                        <div className="content-box-btn">
                            <div className={` ${isEyeActive ? 'head_check_completed' : ' head_check_incompleted'}`}
                                onClick={() => {
                                    if (isEyeActive) {

                                        handleShowModal();

                                    }
                                    else {
                                        handleShow03();
                                    }
                                }}
                                style={{ cursor: 'pointer' }} >
                                <MdRemoveRedEye size={22} />
                            </div>
                        </div>
                    </div>

                    {/* Parent Div for Progress Bars and Tick */}
                    {/* <div class="new-design-header white progress-wrapper-top">
                        <div className="progress-wrapper">
                            <div className="progress-bars-container">


                                <div
                                    className={`progress-bar ${isValidated && (!remotefittingdata[step][iron].shot1.optionx || !remotefittingdata[step][iron].shot1.optiony || !remotefittingdata[step][iron].shot1.option1 || !remotefittingdata[step][iron].shot1.option2) ? 'progress-error' : ''}`}
                                >
                                    <div
                                        className="progress" style={{ width: remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot1 && remotefittingdata[step][iron].shot1.option1 && remotefittingdata[step][iron].shot1.option2 ? '100%' : '0%' }}></div>
                                </div>

                                <div
                                    className={`progress-bar ${isValidated && (!remotefittingdata[step][iron].shot2.optionx || !remotefittingdata[step][iron].shot2.optiony || !remotefittingdata[step][iron].shot2.option1 || !remotefittingdata[step][iron].shot2.option2) ? 'progress-error' : ''}`}
                                >
                                    <div className="progress" style={{ width: remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot2 && remotefittingdata[step][iron].shot2.option1 && remotefittingdata[step][iron].shot2.option2 ? '100%' : '0%' }}></div>
                                </div>


                                <div
                                    className={`progress-bar ${isValidated && (!remotefittingdata[step][iron].shot3.optionx || !remotefittingdata[step][iron].shot3.optiony || !remotefittingdata[step][iron].shot3.option1 || !remotefittingdata[step][iron].shot3.option2) ? 'progress-error' : ''}`}
                                >
                                    <div className="progress" style={{ width: remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot3 && remotefittingdata[step][iron].shot3.option1 && remotefittingdata[step][iron].shot3.option2 ? '100%' : '0%' }}></div>
                                </div>
                            </div>
                        

                            <div class="head_check "><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg></div>
                        </div>
                    </div> */}


                    <div className="new-design-header white progress-wrapper-top">
                        <div className="progress-wrapper">
                            <div className="progress-bars-container">
                                {[1, 2, 3].map(shotNumber => {
                                    const shot = remotefittingdata?.[step]?.[iron]?.[`shot${shotNumber}`];
                                    const isComplete = shot?.optionx && shot?.optiony && shot?.option1 && shot?.option2;
                                    const hasError = isValidated && !isComplete;

                                    return (
                                        <div
                                            key={shotNumber}
                                            className={`progress-bar ${hasError ? 'progress-error' : ''}`}
                                        >
                                            <div
                                                className="progress"
                                                style={{ width: isComplete ? '100%' : '0%' }}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="head_check">
                                <svg viewBox="0 0 24 24" width="32" height="32" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M2 14l7 7 13-13"
                                        stroke={allShotsFilled ? "#98ea24" : "#1e2025"}
                                        strokeWidth="4"
                                        fill="none"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>




                    <Modal show={showModal} onHide={handleCloseModal}
                        keyboard={false}
                        className='new-design-model'
                    >
                        <Modal.Header  >

                            <div className="sec-header-dash border-header-sec white">
                                <div className="box-title mb-0" style={{ color: 'rgb(255, 255, 255)' }}>
                                    <h3 className="box-title-lable"><span className="color">{number}</span> {title}</h3>
                                </div>

                                <button type="button" class="close-btn" aria-label="Close" onClick={handleCloseModal} ><ImCross color='#fff' /></button>

                                {/* <div className="content-box-btn">
                                    <div className="head_check">
                                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" style={{ cursor: 'pointer' }}>
                                            <path fill="none" d="M0 0h24v24H0z"></path>
                                            <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"></path>
                                        </svg>
                                    </div>
                                </div> */}
                            </div>
                            {/* <Modal.Title>{title}</Modal.Title> */}
                        </Modal.Header>
                        <Modal.Body>
                            <div className={`form-box-color custom-select-container p-0 ${dropdownState.isOpen1 ? 'open' : ''}`}>
                                <label className="dashboard-form-lable new-design-label">Shot 1</label>
                                <div className="arrow_svg_image">
                                    <div className='svg-image-design mb-5'>
                                        <StickSvg color={title} shot={1} level={iron} selectedNUmberX={selectedNUmberX} selectedNUmberY={selectedNUmberY} step={step} />
                                    </div>
                                </div>
                                <div className="custom-form-group new-design-form-group">
                                    <label className="dashboard-form-lable">Shot Strike</label>
                                    <div className="w-60">
                                        <div className='drop-down-wrapper strike-drop-down d-flex gap-3'>
                                            <Form.Group className="w-100">
                                                <Form.Select
                                                    required
                                                    aria-label="Shot Shape Select Menu"
                                                    // value={remotefittingdata[step][iron].shot1.optionx ? remotefittingdata[step][iron].shot1.optionx : 'Shot Shape'}
                                                    isInvalid={isValidated && !remotefittingdata[step][iron].shot1.optionx}

                                                    value={remotefittingdata[step][iron].shot1.optionx || ''}
                                                    onChange={(e) => {
                                                        const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                                        const obj = { id: dataId, text: e.target.value }
                                                        handleOptionStrickY(obj, ".shot1.optionx", 1)
                                                    }}

                                                    className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot1 && remotefittingdata[step][iron].shot1.optionx ? 'selected' : ''}`}
                                                    open={true}
                                                >
                                                    <option value='' disabled>
                                                        <span className='new-icon-select-box'>↔</span>
                                                    </option>
                                                    {options2.map((option) => (
                                                        <option key={option.id} value={option.text} data-id={option.id}
                                                        >
                                                            {option.text}

                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select a value.
                                                </Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group className="w-100">
                                                <Form.Select
                                                    required
                                                    aria-label="Shot Shape Select Menu"
                                                    // value={remotefittingdata[step][iron].shot1.optiony ? remotefittingdata[step][iron].shot1.optiony : 'Shot Shape'}
                                                    isInvalid={isValidated && !remotefittingdata[step][iron].shot1.optiony}


                                                    value={remotefittingdata[step][iron].shot1.optiony || ''}
                                                    onChange={(e) => {
                                                        const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                                        const obj = { id: dataId, text: e.target.value }
                                                        handleOptionStrickX(obj, ".shot1.optiony", 1)
                                                    }}

                                                    className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot1 && remotefittingdata[step][iron].shot1.optiony ? 'selected' : ''}`}
                                                    open={true}
                                                >
                                                    <option value="" disabled>
                                                        <span className='new-icon-select-box'>↕</span>
                                                    </option>
                                                    {options2.map((option) => (
                                                        <option key={option.id} value={option.text} data-id={option.id}
                                                        >
                                                            {option.text}

                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select a value.
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="custom-form-group new-design-form-group">
                                    <label className="dashboard-form-lable">Shot Shape</label>
                                    <div className="w-60">
                                        <Form.Group>
                                            <Form.Select
                                                required
                                                aria-label="Shot Shape Select Menu"
                                                isInvalid={isValidated && !remotefittingdata[step][iron].shot1.option1}

                                                value={remotefittingdata[step][iron].shot1.option1 ? remotefittingdata[step][iron].shot1.option1 : ''}
                                                onChange={(e) => {
                                                    const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                                    const obj = { id: dataId, text: e.target.value }
                                                    handleOptionClick1(obj, step + "." + iron + ".shot1.option1")
                                                }}

                                                className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot1 && remotefittingdata[step][iron].shot1.option1 ? 'selected' : ''}`}
                                                open={true}
                                            >
                                                <option value="" disabled>Shot Shape</option>
                                                {options.map((option) => (
                                                    <option key={option.id} value={option.text} data-id={option.id}
                                                    >
                                                        {option.text}

                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                Please select a Shot Shape.
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                    </div>
                                </div>
                                <div className="custom-form-group new-design-form-group">
                                    <label className="dashboard-form-lable">Shot Result</label>
                                    <div className="w-60">

                                        <Form.Group>
                                            <Form.Select
                                                required
                                                aria-label="Shot Result Select Menu"
                                                isInvalid={isValidated && !remotefittingdata[step][iron].shot1.option2}

                                                value={remotefittingdata[step][iron].shot1.option2 ? remotefittingdata[step][iron].shot1.option2 : ''}
                                                onChange={(e) => {
                                                    const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                                    const obj = { id: dataId, text: e.target.value }
                                                    handleOptionClickResult(obj, step + "." + iron + ".shot1.option2")
                                                }}
                                                className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot1 && remotefittingdata[step][iron].shot1.option2 ? 'selected' : ''}`}
                                            >
                                                <option value="" disabled>Shot Result</option>
                                                {shotOpction.map((option) => (
                                                    <option key={option.id} value={option.text} data-id={option.id}
                                                    >
                                                        {option.text}

                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                Please select a Shot Result.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                </div>
                            </div>

                            <div className={`form-box-color custom-select-container  p-0 ${dropdownState2.isOpen1 ? 'open' : ''}`}>
                                <label className="dashboard-form-lable new-design-label">Shot 2</label>
                                <div className="arrow_svg_image">
                                    <div className='svg-image-design mb-5'>
                                        <StickSvg color={title} shot={2} level={iron} selectedNUmberX={selectedNUmberX} selectedNUmberY={selectedNUmberY} step={step} />
                                    </div>
                                </div>
                                <div className="custom-form-group new-design-form-group">
                                    <label className="dashboard-form-lable">Shot Strike</label>
                                    <div className="w-60">
                                        <div className='drop-down-wrapper strike-drop-down d-flex gap-3'>

                                            <Form.Group className='w-100'>
                                                <Form.Select
                                                    required
                                                    aria-label="Shot Shape Select Menu"
                                                    isInvalid={isValidated && !remotefittingdata[step][iron].shot2.optionx}

                                                    // value={remotefittingdata[step][iron].shot2.optionx ? remotefittingdata[step][iron].shot2.optionx : 'Shot Shape'}
                                                    value={remotefittingdata[step][iron].shot2.optionx || ''}
                                                    onChange={(e) => {
                                                        const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                                        const obj = { id: dataId, text: e.target.value }
                                                        handleOptionStrickY(obj, ".shot2.optionx", 2)
                                                    }}

                                                    className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot2 && remotefittingdata[step][iron].shot2.optionx ? 'selected' : ''}`}
                                                    open={true}
                                                >
                                                    <option value='' disabled>
                                                        <span className='new-icon-select-box'>↔</span>
                                                    </option>
                                                    {options2.map((option) => (
                                                        <option key={option.id} value={option.text} data-id={option.id}
                                                        >
                                                            {option.text}

                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select a value.
                                                </Form.Control.Feedback>
                                            </Form.Group>


                                            <Form.Group className='w-100'>
                                                <Form.Select
                                                    required
                                                    aria-label="Shot Shape Select Menu"
                                                    // value={remotefittingdata[step][iron].shot2.optiony ? remotefittingdata[step][iron].shot2.optiony : 'Shot Shape'}
                                                    isInvalid={isValidated && !remotefittingdata[step][iron].shot2.optiony}

                                                    value={remotefittingdata[step][iron].shot2.optiony || ''}
                                                    onChange={(e) => {
                                                        const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                                        const obj = { id: dataId, text: e.target.value }
                                                        handleOptionStrickX(obj, ".shot2.optiony", 2)
                                                    }}

                                                    className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot2 && remotefittingdata[step][iron].shot2.optiony ? 'selected' : ''}`}
                                                    open={true}
                                                >
                                                    <option value="" disabled>
                                                        <span className='new-icon-select-box'>↕</span>
                                                    </option>
                                                    {options2.map((option) => (
                                                        <option key={option.id} value={option.text} data-id={option.id}
                                                        >
                                                            {option.text}

                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select a value.
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="custom-form-group new-design-form-group">
                                    <label className="dashboard-form-lable">Shot Shape</label>
                                    <div className="w-60">
                                        <Form.Group>
                                            <Form.Select
                                                required
                                                aria-label="Shot Result Select Menu"
                                                isInvalid={isValidated && !remotefittingdata[step][iron].shot2.option1}

                                                value={remotefittingdata[step][iron].shot2.option1 ? remotefittingdata[step][iron].shot2.option1 : ''}
                                                onChange={(e) => {
                                                    const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                                    const obj = { id: dataId, text: e.target.value }
                                                    handleOptionClick1(obj, step + "." + iron + ".shot2.option1")
                                                }}
                                                className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot2 && remotefittingdata[step][iron].shot2.option1 ? 'selected' : ''}`}
                                            >
                                                <option value="" disabled>Shot Shape</option>
                                                {options.map((option) => (
                                                    <option key={option.id} value={option.text} data-id={option.id}
                                                    >
                                                        {option.text}

                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                Please select a Shot Shape.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                </div>
                                <div className="custom-form-group new-design-form-group">
                                    <label className="dashboard-form-lable">Shot Result</label>
                                    <div className="w-60">
                                        <Form.Group>
                                            <Form.Select
                                                required
                                                aria-label="Shot Result Select Menu"
                                                isInvalid={isValidated && !remotefittingdata[step][iron].shot2.option2}

                                                value={remotefittingdata[step][iron].shot2.option2 ? remotefittingdata[step][iron].shot2.option2 : ''}
                                                onChange={(e) => {
                                                    const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                                    const obj = { id: dataId, text: e.target.value }
                                                    handleOptionClickResult(obj, step + "." + iron + ".shot2.option2")
                                                }}
                                                className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot2 && remotefittingdata[step][iron].shot2.option2 ? 'selected' : ''}`}
                                            >
                                                <option value="" disabled>Shot Result</option>
                                                {shotOpction.map((option) => (
                                                    <option key={option.id} value={option.text} data-id={option.id}
                                                    >
                                                        {option.text}

                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                Please select a Shot Result.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                </div>
                            </div>

                            <div className={`form-box-color custom-select-container  p-0 ${dropdownState3.isOpen1 ? 'open' : ''}`}>
                                <label className="dashboard-form-lable new-design-label">Shot 3</label>
                                <div className="arrow_svg_image">
                                    <div className='svg-image-design mb-5'>
                                        <StickSvg color={title} shot={3} level={iron} selectedNUmberX={selectedNUmberX} selectedNUmberY={selectedNUmberY} step={step} />
                                    </div>
                                </div>
                                <div className="custom-form-group new-design-form-group">
                                    <label className="dashboard-form-lable">Shot Strike</label>
                                    <div className="w-60">
                                        <div className='drop-down-wrapper strike-drop-down d-flex gap-3'>
                                            <Form.Group className="w-100">
                                                <Form.Select
                                                    required
                                                    aria-label="Shot Shape Select Menu"
                                                    isInvalid={isValidated && !remotefittingdata[step][iron].shot3.optionx}

                                                    // value={remotefittingdata[step][iron].shot3.optionx ? remotefittingdata[step][iron].shot3.optionx : 'Shot Shape'}
                                                    value={remotefittingdata[step][iron].shot3.optionx || ''}
                                                    onChange={(e) => {
                                                        const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                                        const obj = { id: dataId, text: e.target.value }
                                                        handleOptionStrickY(obj, ".shot3.optionx", 3)
                                                    }}

                                                    className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot3 && remotefittingdata[step][iron].shot3.optionx ? 'selected' : ''}`}
                                                    open={true}
                                                >
                                                    <option value='' disabled>
                                                        <span className='new-icon-select-box'>↔</span>
                                                    </option>
                                                    {options2.map((option) => (
                                                        <option key={option.id} value={option.text} data-id={option.id}
                                                        >
                                                            {option.text}

                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select a Shot Strike.
                                                </Form.Control.Feedback>
                                            </Form.Group>


                                            <Form.Group className="w-100">
                                                <Form.Select
                                                    required
                                                    aria-label="Shot Shape Select Menu"
                                                    isInvalid={isValidated && !remotefittingdata[step][iron].shot3.optiony}
                                                    // value={remotefittingdata[step][iron].shot3.optiony ? remotefittingdata[step][iron].shot3.optiony : 'Shot Shape'}
                                                    value={remotefittingdata[step][iron].shot3.optiony || ''}
                                                    onChange={(e) => {
                                                        const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                                        const obj = { id: dataId, text: e.target.value }
                                                        handleOptionStrickX(obj, ".shot3.optiony", 3)
                                                    }}

                                                    className={`form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot3 && remotefittingdata[step][iron].shot3.optiony ? 'selected' : ''}`}
                                                    open={true}
                                                >
                                                    <option value="" disabled>
                                                        <span className='new-icon-select-box'>↕</span>
                                                    </option>
                                                    {options2.map((option) => (
                                                        <option key={option.id} value={option.text} data-id={option.id}
                                                        >
                                                            {option.text}

                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select a value
                                                </Form.Control.Feedback>
                                            </Form.Group>

                                        </div>
                                    </div>
                                </div>
                                <div className="custom-form-group new-design-form-group">
                                    <label className="dashboard-form-lable">Shot Shape</label>
                                    <div className="w-60">
                                        {/* <div className={`custom-select-wrapper w-100 ${dropdownState3.isOpen1 ? 'open' : ''}`}>
                                <div
                                    className={`selected-option ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot3 && remotefittingdata[step][iron].shot3.option1 ? 'selected' : ''}`}
                                    onClick={() => handleToggleDropdown3('isOpen1')}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                            {remotefittingdata[step][iron].shot3.option1 ? remotefittingdata[step][iron].shot3.option1 : 'Shot Shape'}
                                        </span>
                                    </div>
                                    <i className={`bi ${dropdownState3.isOpen1 ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                </div>
                                {dropdownState3.isOpen1 && (
                                    <div className="options-list">
                                        {options.map((option) => (
                                            <div
                                                key={option.id}
                                                className={`option ${remotefittingdata[step][iron].shot3.option1 && remotefittingdata[step][iron].shot3.option1 === option.text ? 'selected' : ''}`}
                                                onClick={() => handleOptionClick1(option, step + "." + iron + ".shot3.option1")}
                                            >
                                                <div className="custom-option-label">
                                                    <span className="option-text">{option.text}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div> */}
                                        <Form.Group>
                                            <Form.Select
                                                required
                                                aria-label="Shot Result Select Menu"
                                                // value={remotefittingdata[step][iron].shot3.option1 ? remotefittingdata[step][iron].shot3.option1 : 'Shot Result'}
                                                isInvalid={isValidated && !remotefittingdata[step][iron].shot3.option1}
                                                value={remotefittingdata[step][iron].shot3.option1 || ''}
                                                onChange={(e) => {
                                                    const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                                    const obj = { id: dataId, text: e.target.value }
                                                    handleOptionClick1(obj, step + "." + iron + ".shot3.option1")
                                                }}
                                                className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot3 && remotefittingdata[step][iron].shot3.option1 ? 'selected' : ''}`}
                                            >
                                                <option value="" disabled>Shot Shape</option>
                                                {options.map((option) => (
                                                    <option key={option.id} value={option.text} data-id={option.id}
                                                    >
                                                        {option.text}

                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                Please select a Shot Shape
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                </div>
                                <div className="custom-form-group new-design-form-group">
                                    <label className="dashboard-form-lable">Shot Result</label>
                                    <div className="w-60">
                                        {/* <div className={`custom-select-wrapper w-100 ${dropdownState3.isOpen2 ? 'open' : ''}`}>
                                <div
                                    className={`selected-option ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot3 && remotefittingdata[step][iron].shot3.option2 ? 'selected' : ''}`}
                                    onClick={() => handleToggleDropdown3('isOpen2')}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                            {remotefittingdata[step][iron].shot3.option2 ? remotefittingdata[step][iron].shot3.option2 : 'Shot Result'}
                                        </span>
                                    </div>
                                    <i className={`bi ${dropdownState3.isOpen2 ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                </div>
                                {dropdownState3.isOpen2 && (
                                    <div className="options-list">
                                        {shotOpction.map((option) => (
                                            <div
                                                key={option.id}
                                                className={`option ${remotefittingdata[step][iron].shot3.option2 && remotefittingdata[step][iron].shot3.option2 === option.text ? 'selected' : ''}`}
                                                onClick={() => handleOptionClickResult(option, step + "." + iron + ".shot3.option2")}
                                            >
                                                <div className="custom-option-label">
                                                    <span className="option-text">{option.text}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div> */}
                                        <Form.Group>
                                            <Form.Select
                                                required
                                                aria-label="Shot Result Select Menu"
                                                isInvalid={isValidated && !remotefittingdata[step][iron].shot3.option2}
                                                value={remotefittingdata[step][iron].shot3.option2 ? remotefittingdata[step][iron].shot3.option2 : ''}
                                                onChange={(e) => {
                                                    const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                                    const obj = { id: dataId, text: e.target.value }
                                                    handleOptionClickResult(obj, step + "." + iron + ".shot3.option2")
                                                }}
                                                className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot3 && remotefittingdata[step][iron].shot3.option2 ? 'selected' : ''}`}
                                            >
                                                <option value='' disabled>Shot Result</option>
                                                {shotOpction.map((option) => (
                                                    <option key={option.id} value={option.text} data-id={option.id}
                                                    >
                                                        {option.text}

                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                Please select a Shot Result
                                            </Form.Control.Feedback>
                                        </Form.Group>


                                    </div>
                                </div>
                                <button type="submit"
                                    onClick={handleCloseModal}
                                    className="btn btn-primary btn-create" style={{
                                        width: '90%', marginTop: '15px', marginLeft: '5%', marginBottom: '15px', fontSize: '20px', fontWeight: '600'
                                    }}>Save Club Data</button>
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
            </div>







        </>
    );
});

export default IronsData;
